import { useQuery, UseQueryOptions } from 'react-query';
import { indexUserLoyaltyCards } from 'services/api-ops.service';
import { ILoyaltyCard } from 'shared/consts/loyalty.const';

const GET_LOYALTY_CARD = 'get_loyalty_card';

export const useIndexUserLoyaltyCards = (
  userId: string,
  options?: UseQueryOptions<ILoyaltyCard, unknown>
) =>
  useQuery(
    [GET_LOYALTY_CARD, userId],
    () => indexUserLoyaltyCards(userId),
    options
  );
